import {
  RESET_SITE_ROLES,
  RESET_SITE_ROLES_CHANGE,
  UPDATE_SITE_ROLES_CHANGE,
  UPDATE_SITE_ROLES,
  FETCH_SITE_ROLES,
  FETCH_SITE_ROLES_START,
  FETCH_SITE_ROLES_SUCCESS,
  FETCH_SITE_ROLES_ERROR,
  POST_SITE_ROLES,
  POST_SITE_ROLES_START,
  POST_SITE_ROLES_SUCCESS,
  POST_SITE_ROLES_ERROR,
} from './constants'

const resetSiteRoles = () => ({ type: RESET_SITE_ROLES })
const resetSiteRolesChange = () => ({ type: RESET_SITE_ROLES_CHANGE })
const updateSiteRoles = (team) => ({ type: UPDATE_SITE_ROLES, team })
const updateSiteRolesChange = (team, role) => ({ type: UPDATE_SITE_ROLES_CHANGE, team, role })
const fetchSiteRoles = (partnerSiteId) => ({ type: FETCH_SITE_ROLES, partnerSiteId })
const fetchSiteRolesStart = () => ({ type: FETCH_SITE_ROLES_START })
const fetchSiteRolesSuccess = () => ({ type: FETCH_SITE_ROLES_SUCCESS })
const fetchSiteRolesError = (error) => ({ type: FETCH_SITE_ROLES_ERROR, error })
const postSiteRoles = (partnerSiteId) => ({ type: POST_SITE_ROLES, partnerSiteId })
const postSiteRolesStart = () => ({ type: POST_SITE_ROLES_START })
const postSiteRolesSuccess = () => ({ type: POST_SITE_ROLES_SUCCESS })
const postSiteRolesError = (error) => ({ type: POST_SITE_ROLES_ERROR, error })

export {
  resetSiteRoles,
  resetSiteRolesChange,
  updateSiteRoles,
  updateSiteRolesChange,
  fetchSiteRoles,
  fetchSiteRolesStart,
  fetchSiteRolesSuccess,
  fetchSiteRolesError,
  postSiteRoles,
  postSiteRolesStart,
  postSiteRolesSuccess,
  postSiteRolesError,
}
